import qs from "qs"
import Axios from "axios"

export class Report {
  constructor(apiUrl, headers) {
    // Set report API URL
    this.reportUrl = `${apiUrl}/report`

    this.headers = headers
  }

  async getGiftBoxReports(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false,
    })

    const url = `${this.reportUrl}/morning-coin/gift-boxes${queryString}`

    const response = await Axios.get(url, { headers: this.headers })

    return response
  }

  async downloadGiftBoxReports(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false,
    })

    const url = `${this.reportUrl}/morning-coin/gift-boxes/download${queryString}`

    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    }

    const response = await Axios.get(url, {
      headers: blobHeaders,
      responseType: "blob",
    })

    return response
  }

  async downloadTransferHomeMncStatusReport(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false,
    })

    const url = `${this.reportUrl}/morning-coin/transfer-home-mnc-status${queryString}`

    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    }

    const response = await Axios.get(url, {
      headers: blobHeaders,
      responseType: "blob",
    })

    return response
  }

  async downloadBalanceSnapshotReport(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false,
    })

    const url = `${this.reportUrl}/morning-coin/balance-snapshot${queryString}`

    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    }

    const response = await Axios.get(url, {
      headers: blobHeaders,
      responseType: "blob",
    })

    return response
  }

  async getMncEvents() {
    const url = `${this.reportUrl}/morning-coin/mnc-events`

    const response = await Axios.get(url, { headers: this.headers })

    return response
  }

  async getEarnReport(params) {
    //
    let response = null

    try {
      // Set Query String
      const queryString = qs.stringify(params, {
        addQueryPrefix: true,
        indices: false,
        allowEmptyArrays: true,
      })

      // Set URL
      const url = `${this.reportUrl}/morning-coin/earn${queryString}`

      // Set Config
      const config = {
        headers: this.headers,
      }

      // Validate IsDownload
      if (params.download) {
        config.headers.Accept = "application/octet-stream"
        config.responseType = "blob"
      }

      // Request
      response = await Axios.get(url, config)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("report earn error", error.message || "")
      throw error
    }

    return response
  }

  async getTransferReport(params) {
    // Initial Result
    let response = null

    try {
      // Set Query String
      const queryString = qs.stringify(params, {
        addQueryPrefix: true,
        indices: false,
        allowEmptyArrays: true,
      })

      // Set URL
      const url = `${this.reportUrl}/morning-coin/transfer${queryString}`

      // Set Config
      const config = {
        headers: this.headers,
      }

      // Validate IsDownload
      if (params.download) {
        config.headers.Accept = "application/octet-stream"
        config.responseType = "blob"
      }

      // Request
      response = await Axios.get(url, config)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("report transfer home error", error.message || "")
      throw error
    }

    return response
  }

  async getEarnReportCompany() {
    try {
      // Set URL
      const url = `${this.reportUrl}/morning-coin/earn/company`

      // Request
      const response = await Axios.get(url, { headers: this.headers })

      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("report earn report company error", error.message || "")
      throw error
    }
  }
}
